<template>
  <section class="register-progress">
    <h2 class="register-progress__title">{{ $t("register.title") }}</h2>
    <ProgressPoint
      v-if="region !== 'mena'"
      :filled="true"
      :number="1"
      :from="numberPoint"
      :title="textPoint[0].title"
      :body="textPoint[0].text"
    >
    </ProgressPoint>
    <ProgressPoint
      v-if="region !== 'mena'"
      :filled="false"
      :number="2"
      :from="numberPoint"
      :title="textPoint[1].title"
      :body="textPoint[1].text"
    >
    </ProgressPoint>
    <ProgressPoint
      v-if="region !== 'mena'"
      :filled="false"
      :number="3"
      :from="numberPoint"
      :title="textPoint[2].title"
      :body="textPoint[2].text"
    >
    </ProgressPoint>
    <ProgressPoint
      v-if="liveAccount && region !== 'mena'"
      :filled="false"
      :number="4"
      :from="numberPoint"
      :title="textPoint[3].title"
      :body="textPoint[3].text"
    >
    </ProgressPoint>
    <p class="descrDemo" v-if="!liveAccount">
      {{ $t("register.youcan") }}
      <strong style="font-weight: 400">{{ $t("register.freeDemo") }}</strong>
      {{ $t("register.desYouCan") }}
      <strong style="font-weight: 400">{{ $t("register.client") }}</strong
      >{{ $t("register.desYouCan2") }}
    </p>
    <p class="goBack">
      <a :href="pageContact">
        <img src="/assets/images/menorque.png" alt="" />
        {{ $t("register.goBack") }}</a
      >
    </p>
  </section>
</template>

<script>
import { onMounted, ref } from "@vue/runtime-core";
import ProgressPoint from "@/components/login/ProgressPoint";
import { i18n } from "@/plugins/i18n";

export default {
  name: "Progress",
  components: {
    ProgressPoint,
  },
  setup() {
    let pageContact = "/login";
    let liveAccount = ref(false);
    let textPoint = ref([]);
    let numberPoint = ref(0);
    const region = ref(process.env.VUE_APP_CABINET_ORIGIN);

    onMounted(() => {
      accountTypeOpen();
      console.log(liveAccount.value);
    });

    const accountTypeOpen = () => {
      console.log("entreee");
      if (
        window.location.pathname === "/register/1/live-account" ||
        window.location.pathname === "/register/2/live-account"
      ) {
        console.log("entre live");
        liveAccount.value = true;
        numberPoint.value = 4;
        textPoint.value = [
          {
            title: i18n.global.t("register.create"),
            text: i18n.global.t("register.createdes"),
          },
          {
            title: i18n.global.t("register.complete"),
            text: i18n.global.t("register.completedes"),
          },
          {
            title: i18n.global.t("register.confirm"),
            text: i18n.global.t("register.confirmdes"),
          },
          {
            title: i18n.global.t("register.fund"),
            text: i18n.global.t("register.funddes"),
          },
        ];
      } else if (
        window.location.pathname === "/register/1/demo-account" ||
        window.location.pathname === "/register/2/demo-account"
      ) {
        console.log("entre demo");
        liveAccount.value = false;
        numberPoint.value = 3;
        textPoint.value = [
          {
            title: i18n.global.t("register.create"),
            text: i18n.global.t("register.createdes"),
          },
          {
            title: i18n.global.t("register.practice"),
            text: i18n.global.t("register.practicedes"),
          },
          {
            title: i18n.global.t("register.learn"),
            text: i18n.global.t("register.learndes"),
          },
        ];
      }
    };

    return {
      pageContact,
      accountTypeOpen,
      textPoint,
      liveAccount,
      numberPoint,
      region
    };
  },
};
</script>

<style scoped>
</style>
